import React, { useEffect } from "react";
import { Form, Row, Col, Divider, Drawer, FormInstance } from "antd";
import DynamicFormItem from "./DynamicFormItem";
import FilterActions from "./FilterActions";

/** 🔹 Types */
interface FormFieldConfig {
  name: string;
  span?: number;
  [key: string]: any; // keep flexible for dynamic fields
}

interface DrawerConfig {
  visible: boolean;
  content: React.ReactNode;
}

interface DynamicFilterFormProps {
  formConfig: {
    basicFields?: FormFieldConfig[];
    advancedFields?: FormFieldConfig[];
    submitText?: string;
    resetText?: string;
  };
  form: FormInstance;
  initialValues?: Record<string, any>;
  onFinish: (values: any) => void;
  onReset: () => void;
  layout?: "horizontal" | "vertical" | "inline";
  gutter?: [number, number];
  showAdvanced?: boolean;
  drawerConfig?: DrawerConfig;
}

const DynamicFilterForm: React.FC<DynamicFilterFormProps> = ({
  formConfig,
  form,
  initialValues,
  onFinish,
  onReset,
  layout = "vertical",
  gutter = [32, 0],
  showAdvanced = true,
  drawerConfig,
}) => {
  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue(initialValues);
    }
  }, [initialValues, form]);

  return (
    <>
      <Form
        form={form}
        layout={layout}
        onFinish={onFinish}
        className="dynamic-filter-form pb-2"
      >
        <Row gutter={gutter}>
          {formConfig?.basicFields?.map((field: any) => (
            <Col key={field.name} span={field.span || 12}>
              <DynamicFormItem field={field} form={form} />
            </Col>
          ))}

          {showAdvanced && formConfig?.advancedFields && (
            <>
              <Divider orientation="left" plain>
                Advanced Filter
              </Divider>

              {formConfig.advancedFields.map((field: any) => (
                <Col key={field.name} span={field.span || 12}>
                  <DynamicFormItem field={field} form={form} />
                </Col>
              ))}
            </>
          )}
        </Row>

        {/* 🔹 Sticky Footer */}
        <Row
          style={{
            position: "absolute",
            bottom: 0,
            backgroundColor: "#fff",
            paddingTop: 15,
            width: "100%",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            paddingRight: 60,
          }}
        >
          <FilterActions
            onReset={onReset}
            submitText={formConfig?.submitText}
            resetText={formConfig?.resetText}
          />
        </Row>

        {/* 🔹 Drawer */}
        {drawerConfig && (
          <Drawer
            footer={null}
            title=""
            placement="right"
            size="default"
            closable={false}
            open={drawerConfig.visible}
            bodyStyle={{ padding: 0 }}
          >
            {drawerConfig.content}
          </Drawer>
        )}
      </Form>
    </>
  );
};

export default DynamicFilterForm;
